import { format, isValid, parseISO } from "date-fns";
export const formatFinancialMoney = value => {
  const match = String(value == null ? "" : value).match(/^(-?)(\d+)(?:\.(\d{1,2}))?$/);
  if (!match) return "—";
  const integer = match[2].replace(/^0+(?=\d)/, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${match[1]}R$ ${integer},${(match[3] || "").padEnd(2, "0")}`;
};

export const financialStatusLabel = status => ({
  OTHER: "Outros status", RECEIVED_IN_CASH: "Recebido em dinheiro", PARTIALLY_REFUNDED: "Estornado parcialmente",
  OPEN: "Em aberto", PENDING: "Pendente", OVERDUE: "Vencido",
  PAID: "Pago", RECEIVED: "Recebido", CONFIRMED: "Confirmado",
  CANCELLED: "Cancelado", DELETED: "Excluído", REFUNDED: "Estornado",
}[status] || status);

export const financialLocalDate = (now = new Date()) => {
  const parts = new Intl.DateTimeFormat("en", { timeZone: "America/Sao_Paulo", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(now);
  const part = type => parts.find(p => p.type === type)?.value;
  return `${part("year")}-${part("month")}-${part("day")}`;
};

export const financialDateForPicker = value => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) return null;
  const date = parseISO(value);
  return isValid(date) && format(date, "yyyy-MM-dd") === value ? date : null;
};
export const financialDateFromPicker = date => date && isValid(date) ? format(date, "yyyy-MM-dd") : "";
